module.exports = __webpack_public_path__ + "合作6.png?4fe6069d524d48b86d341c853f57f579";


//////////////////
// WEBPACK FOOTER
// ./src/assets/合作6.png
// module id = 648
// module chunks = 0